import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TextField } from '@mui/material';
import dayjs from 'dayjs';
import 'dayjs/locale/pl';

import * as Styled from './DatePicker.styles';

export const DatePicker = ({ label, value, onChange, minDate, maxDate, error }) => {
  const [open, setOpen] = useState(false);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pl">
      <Styled.Wrapper>
        <DesktopDatePicker
          className="datePicker"
          open={open}
          onOpen={() => setOpen(true)}
          onClose={() => setOpen(false)}
          label={value ? label : null}
          value={value ? dayjs(value) : null}
          minDate={minDate}
          maxDate={maxDate}
          onChange={(value) => onChange(value.format('YYYY-MM-DD'))}
          renderInput={(params) => (
            <TextField
              {...params}
              inputProps={{ ...params.inputProps, readOnly: true, placeholder: label }}
              onClick={() => setOpen(true)}
              error={!!error}
              helperText={error}
              fullWidth
            />
          )}
        />
      </Styled.Wrapper>
    </LocalizationProvider>
  );
};

DatePicker.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  minDate: PropTypes.string,
  maxDate: PropTypes.string,
  error: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};
